import { render } from "./TpvConfirmationModal.vue?vue&type=template&id=0d8e8fb4&scoped=true"
import script from "./TpvConfirmationModal.vue?vue&type=script&lang=js"
export * from "./TpvConfirmationModal.vue?vue&type=script&lang=js"

import "./TpvConfirmationModal.vue?vue&type=style&index=0&id=0d8e8fb4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d8e8fb4"]])

export default __exports__